import { NgModule } from '@angular/core';

@NgModule({
  providers: [AssignmentStatusModule]
})
export class AssignmentStatusModule { }
